export default __webpack_public_path__ + "static/media/Dracula_Normal_B.5a3eca91.wav";